<template>
  <fy-form :model="form_info" :rules="rules" class="fy-form-login-pc" ref="form" v-if="!isInit">
    <div class="wrap1920" id="indexContent">
      <div class="wrap">
        <div class="tourism_main">
          <login-logo></login-logo>
          <div class="logonRight">
            <p>
              <img src="@/assets/images/html/logon01.jpg">
            </p>
            <div class="reg_top_line_pc">
              <em>1. 输入基本信息</em>
              <i>></i>
              <p>2. 设置密码</p>
            </div>
            <p>
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.name.field_enname">
                <fy-input
                  :placeholder="fields.name.field_placeholder"
                  type="text"
                  v-model.trim="form_info.name"
                ></fy-input>
              </fy-form-item>
            </p>
            <p class="p2 sms-code">
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.username.field_enname">
                <fy-input
                  :placeholder="fields.username.field_placeholder"
                  type="text"
                  v-model.trim="form_info.username"
                ></fy-input>
              </fy-form-item>
              <input
                @click="sendCode"
                class="submitBtn"
                id="send_code"
                name="code"
                type="button"
                value="发送验证码"
              >
            </p>
            <p class="p2" style="margin-top: 19px;">
              <em></em>
              <fy-form-item :inner_width="'100%'" :prop="fields.code.field_enname">
                <fy-input
                  :placeholder="fields.code.field_placeholder"
                  type="text"
                  v-model.trim="form_info.code"
                ></fy-input>
              </fy-form-item>
            </p>
            <a @click="next" class="submitBtn" href="javascript:void(0);">下一步</a>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </fy-form>
</template>
<script>
import { LoginLogo } from '@/pages/components'
import smsCode from '@/api/smsCode'
export default {
  name: 'Regist',
  componentName: 'Regist',
  components: {
    LoginLogo
  },
  data () {
    return {
      url: 'member/regist',
      send_code_url: 'sms_check_code/send_quick_regist_sms_check_code/',
      message: '',
      form_info: {
        username: '',
        name: '',
        code: ''
      },
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      fields: {},
      rules: {}
    }
  },
  created () {
    this.$pageField.init(this, 'fields', 'regist').then(res => {
      this.isInit = false //异步加载完成后设置为true
    })
  },
  methods: {
    sendCode (event) {
      const el = event.currentTarget
      this.$refs.form.validateField('username', (message, invalidFields) => {
        if (message) {
          this.$msg(message, 'error')
        } else {
          let param = smsCode.butResendCountdown(el)
          this.$myPost(this.send_code_url + this.form_info.username)
            .then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$msg('短信验证码发送成功', 'info', 1000);
              } else {
                smsCode.butReset(el, param)
                this.$msg(res.response.data.messages[0].msg, 'info', 1000);
              }
            })
            .catch(err => {
              smsCode.butReset(el, param)
              this.$msg('[' + err.status + ']' + err.message, 'error')
            })
        }
      })
    },
    next () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.$myGet(this.url, this.form_info)
            .then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$sessionStorageUtil.set(
                  'regist_user_info',
                  this.form_info,
                  60 * 10
                )
                this.$pushByName('regist2')
              } else {
                this.$msg(
                  '[' + res.status + ']' + res.response.data.messages[0].msg, 'error'
                )
              }
            })
            .catch(err => {
              this.$msg('[' + err.status + ']' + err.message, 'error')
            })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/user/regist.vue